import { InlineMath } from "react-katex";
import { constructInputWithSpecialExpressionList } from "../../utilization/CatchtivityUtilization";
import { IInputWithSpecialExpressionProps } from "../../properties/TextProperties";

const InputWithSpecialExpression = ({
  value,
  showSpecialOnly,
}: IInputWithSpecialExpressionProps) => {
  const inputWithSpecialExpressionList =
    constructInputWithSpecialExpressionList(value);

  return showSpecialOnly ? (
    inputWithSpecialExpressionList.length > 1 ? (
      <div className="txt-se-wrap">
        <span className="txt-se-pre">
          {inputWithSpecialExpressionList.map((inputPart, index) => (
            <span
              key={index}
              className={`${inputPart.isBold ? "txt-se-bold" : ""} ${
                inputPart.isUnderline ? "txt-se-underline" : ""
              }`}
            >
              {inputPart.isEquation ? (
                <span className="txt-se-eq">
                  <InlineMath math={inputPart.value} />
                </span>
              ) : (
                inputPart.value
              )}
            </span>
          ))}
        </span>
      </div>
    ) : null
  ) : (
    <div className="txt-se-wrap">
      <span className="txt-se-pre">
        {inputWithSpecialExpressionList.map((inputPart, index) => (
          <span
            key={index}
            className={`${inputPart.isBold ? "txt-se-bold" : ""} ${
              inputPart.isUnderline ? "txt-se-underline" : ""
            }`}
          >
            {inputPart.isEquation ? (
              <span className="txt-se-eq">
                <InlineMath math={inputPart.value} />
              </span>
            ) : (
              inputPart.value
            )}
          </span>
        ))}
      </span>
    </div>
  );
};

export default InputWithSpecialExpression;
